export const GetLists = async (setLists,setGotLists,username) => {
    let path = process.env.REACT_APP_BASE_URL + `/lists/getLists?username=${username}`;
    let res = await fetch(process.env.REACT_APP_BASE_URL + `/lists/getLists?username=${username}`, { method: 'post', mode: 'cors', credentials: "include"});
    let data = await res.json();
    setLists(data);
    setGotLists(true);
}